import React from 'react';
import { motion } from 'framer-motion';
interface CTAButtonProps {
  children: React.ReactNode;
  className?: string;
  onClick?: () => void;
}
const CTAButton: React.FC<CTAButtonProps> = ({
  children,
  className = '',
  onClick
}) => {
  return <motion.button className={`bg-primary text-white font-semibold py-3 px-8 rounded-full text-lg shadow-lg hover:bg-primary-dark transition-colors duration-300 ${className}`} whileHover={{
    scale: 1.05
  }} whileTap={{
    scale: 0.95
  }} onClick={onClick} data-id="element-65">
      {children}
    </motion.button>;
};
export default CTAButton;